import {createSlice} from '@reduxjs/toolkit';

export const checkoutSlice = createSlice({
  name: 'checkout',
  initialState: {cout: []},
  reducers: {
    assignCout: (state, action) => {
      state.cout = action.payload;
    },
    clearCout: (state) => {
      state.cout = [];
    },
  },
});

export const {assignCout, clearCout} = checkoutSlice.actions;

export const getCout = (state) => state.checkout.cout;

export default checkoutSlice.reducer;
